/* eslint no-param-reassign: 0 */
import MdmMixin from 'client/store/mixins/MdmMixin';
import MdmsApi from 'client/api/v2/MdmsApi';
import createModel from 'client/store/modules/models/createModel';

/**
 * @description This model represents the information related to MDM settings
 * that can be configured on the 'MDM' page. If new features are added, then add
 * corresponding fields here if needed.
 */
export const getDefaultItem = () => ({
  mdmDevices: [],
});

export const createMdmSettingsModel = () => {
  const model = createModel(getDefaultItem, '_id', MdmsApi);

  return {
    namespaced: true,

    state: {
      ...model.state,
    },

    actions: {
      ...model.actions,

      async createMdmSettings({ commit, state }) {
        await MdmMixin.actions.createMdmSettings({ commit, state });
      },

      deleteMdmConfiguration({ getters }) {
        return MdmsApi.deleteMdmConfiguration(getters.getDmId);
      },

      enrollmentProfiles({ state }) {
        return MdmMixin.actions.enrollmentProfiles(state);
      },
      fetchAvailableOSUpdates({ commit, state }, payload = {}) {
        return MdmMixin.actions.fetchAvailableOSUpdates({ commit, state }, payload);
      },
      fetchBypassCodes({ state }, payload = {}) {
        return MdmMixin.actions.fetchBypassCodes(state, payload);
      },

      fetchCSRCertificate({ getters }) {
        return MdmsApi.fetchCSRCertificate(getters.getDmId);
      },

      fetchDEPCertificate({ getters }) {
        return MdmsApi.fetchDEPCertificate(getters.getDmId);
      },

      fetchDepDevices({ state }, { limit, skip }) {
        return MdmMixin.actions.fetchDepDevices(state, limit, skip);
      },

      fetchEnrollmentProfileDownloadUrl({ state }) {
        return MdmMixin.actions.fetchEnrollmentProfileDownloadUrl(state);
      },

      async fetchMdmSettings({ commit }) {
        await MdmMixin.actions.fetchMdmSettings({ commit });
      },

      getMobileConfig({ getters }, { enrollmentProfileId }) {
        return MdmsApi.getMobileConfig(getters.getDmId, enrollmentProfileId);
      },

      refreshActivationLockInformation({ state }, payload = {}) {
        return MdmMixin.actions.refreshActivationLockInformation(state, payload);
      },

      postClearActivationLock({ state }, payload = {}) {
        return MdmMixin.actions.postClearActivationLock(state, payload);
      },

      postScheduleOSUpdate({ state }, payload = {}) {
        return MdmMixin.actions.postScheduleOSUpdate(state, payload);
      },

      refreshDepDevices({ state }) {
        return MdmMixin.actions.refreshDepDevices(state);
      },

      updateDep({ state }, payload = {}) {
        return MdmMixin.actions.updateDep(state, payload);
      },
    },

    getters: {
      ...model.getters,
      isApnsPushTopicEmpty(state) {
        return MdmMixin.getters.isApnsPushTopicEmpty(state);
      },
      getCreatorAppleId(state) {
        return MdmMixin.getters.getCreatorAppleId(state);
      },
      getDmId(state) {
        return MdmMixin.getters.getDmId(state);
      },
      getDepTokenExpiry(state) {
        return MdmMixin.getters.getDepTokenExpiry(state);
      },
      getDepTokenState(state) {
        return MdmMixin.getters.getDepTokenState(state);
      },
    },

    mutations: {
      ...model.mutations,
    },
  };
};

export default createMdmSettingsModel();
